export const LOCALE_KEY = 'footer';
